export default "__VITE_ASSET__e811ea9d__"